import { render } from "./IconAlertTriangle.vue?vue&type=template&id=71d0f6e5"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconAlertTriangle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71d0f6e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71d0f6e5', __exports__)) {
    api.reload('71d0f6e5', __exports__)
  }
  
  module.hot.accept("./IconAlertTriangle.vue?vue&type=template&id=71d0f6e5", () => {
    api.rerender('71d0f6e5', render)
  })

}


export default __exports__